import type { JSX } from 'react';
import { FormSection } from '@ksyos/design-system';
import { BariatricsExternalReferral } from './BariatricsExternalReferral';

export function BariatricsExternalReferralEdit(): JSX.Element {
    return (
        <FormSection>
            <BariatricsExternalReferral />
        </FormSection>
    );
}
